import { render } from "./NormalChannelDataStatistics.vue?vue&type=template&id=044aebe3&scoped=true"
import script from "./NormalChannelDataStatistics.vue?vue&type=script&lang=js"
export * from "./NormalChannelDataStatistics.vue?vue&type=script&lang=js"

import "./NormalChannelDataStatistics.vue?vue&type=style&index=0&id=044aebe3&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-044aebe3"]])

export default __exports__